/**************************************
  		Equal Height Functionn
**************************************/
// Equal Height Funtion
equalheight = function(container){
	var currentTallest = 0, currentRowStart = 0, rowDivs = new Array(), $el, topPosition = 0;
	$(container).each(function() {
		$el = $(this);
		$($el).height('auto')
		topPostion = $el.position().top;
		if (currentRowStart != topPostion) {
			for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
				rowDivs[currentDiv].height(currentTallest);
			}
			rowDivs.length = 0; // empty the array
			currentRowStart = topPostion;
			currentTallest = $el.outerHeight();
			rowDivs.push($el);
		} else {
			rowDivs.push($el);
			currentTallest = (currentTallest < $el.outerHeight()) ? ($el.outerHeight()) : (currentTallest);
		}
		for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
			rowDivs[currentDiv].height(currentTallest);
		}
	});
}

$(document).ready(function(){
	$(window).on('resize load', function(){
      equalheight('.home_product_line_section .item_title');
      equalheight('.home_product_line_section .item_description_inner');
      equalheight('.home_product_preview_section .preview-desc');
      equalheight('.home_product_preview_section .preview-title h2');
      equalheight('.cart_main_section .related_item_title h6');
      equalheight('.home_badge_section .badge_img_div');
      equalheight('.about_us_section .journey_block');
      equalheight('.scrollable-wrapper h3');
      // equalheight('.product_line_grid .product_card_title h6');
      // equalheight('.home_badge_section .badge_img ');
      // equalheight('.home_product_preview_section .preview-title');
	});
  
}); 

$(document).ready(function(){
	$(window).on('resize load', function(){
      if($( window ).width()>=991){
        let height = 0;
        $('.about_us_section .journey_block').each(function(){
          console.log($(this).height());
          console.log('journey_block',$(this),$(this).position().top);
          if($(this).height()>height){
            height=$(this).height();
          }
        })
        console.log("height : ",height);
        $('.about_us_section .journey_block').each(function(){
          $(this).height(height);
          console.log($(this).height());
        })
        }
	});  
}); 



$(function ($) {

  /*---------------- Responsive Menu ------------------*/ 
  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-bar").toggleClass("off-canvas");
    e.preventDefault();
  });
  if ($(window).width() < 768) {
    $('.menu-bar .menu-toggle > span').on("click", function (e) {
      $(this).parent('.menu-toggle').next('.menu-dropdown').slideToggle(600);
      $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
      e.stopPropagation();
      e.preventDefault();
    });
  }



  
  /*---------------- Responsive Menu ------------------*/

  /*---------------- Main Slider ------------------*/
  $('.main-slider').slick({
    autoplay: false,
    infinite: false,
    arrows: false,
    dots: true
  });


  /*---------------- trendingnow Slider ------------------*/
  $('.trendingnow').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  /*---------------- Reviews Slider ------------------*/
  $('.reviews-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.reviews-nav .slide-prev'),
    nextArrow: $('.reviews-nav .slide-next'),
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });


  /* Blog slider start*/ 
  /*---------------- Blog Slider ------------------*/

  var Rows = 1;
  $(window).on('resize', function(){
    var Rows = 1;
    var viewportWidth = $(window).width();
    if( viewportWidth > 576 ){
      var Rows = 1;
    } else if( viewportWidth < 576 ){
      var Rows = 2;
    }
  });

  var viewportWidth = $(window).width();
  if( viewportWidth > 576 ){
    var Rows = 1;
  } else if( viewportWidth < 576 ){
    var Rows = 2;
  }

  $('.blog-slider').slick({
    rows: Rows,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1
        }
      }
      // { 
      //     breakpoint: 576,
      //     settings: {
      //         rows: 2,
      //         slidesToShow: 1
      //     }
      // }
    ]
  });

  /*---------------- Blog Slider End------------------*/ 


  /*---------------- Shop Slider ------------------*/

  //     $('.shop-slider').slick({
  // slidesToShow: 1,
  // slidesToScroll: 1,
  // arrows: false,
  // vertical: true,
  // verticalSwiping: true,
  // asNavFor: '.shop-slider-nav'
  // });
  // $('.shop-slider-nav').slick({
  // slidesToShow: 4,
  // slidesToScroll: 1,
  // asNavFor: '.shop-slider',
  // dots: false,
  // arrows: false,
  // centerMode: false,
  // vertical: true,
  // verticalSwiping: true,
  // focusOnSelect: true,

  // });


  // $('.shop-slider').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: false,
  //     fade: true,
  //     asNavFor: '.shop-slider-nav'
  // });
  // $('.shop-slider-nav').slick({
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     asNavFor: '.shop-slider',
  //     dots: false,
  //     arrows: false,
  //     focusOnSelect: true,
  //     vertical:true,
  //     verticalSwiping:true,
  //     responsive: [

  //         {
  //             breakpoint: 1200,
  //             settings: {
  //                 slidesToShow: 4,
  //                 slidesToScroll: 1
  //             }
  //         },          
  //         {
  //             breakpoint: 768,
  //             settings: {
  //                 slidesToShow: 4,
  //                 slidesToScroll: 1,
  //                 vertical:false, 
  //             }
  //         },
  //         {
  //             breakpoint: 600,
  //             settings: {
  //                 slidesToShow: 4,
  //                 slidesToScroll: 1,
  //                 vertical:false,
  //             }
  //         },
  //         {
  //             breakpoint: 480,
  //             settings: {
  //                 slidesToShow: 3,
  //                 slidesToScroll: 1,
  //                 vertical:false,
  //             }
  //         },
  //         {
  //             breakpoint: 360,
  //             settings: {
  //                 slidesToShow: 2,
  //                 slidesToScroll: 1,
  //                 vertical:false,
  //             }
  //         }

  //     ]
  // });

  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
        }
      },
      {
        breakpoint: 381,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false,
        }
      }
    ]
  });

  /*---------------- List/Grid View ------------------*/
  $('.grid-view').on('click', function (e) {
    $('.forlistview').removeClass('list').addClass('medium-up--one-third');
  });
  $('.list-view').on('click', function (e) {
    $('.forlistview').removeClass('medium-up--one-third').addClass('list');
  });



  /*---------------- Equal Height Div ------------------*/

  var maxHeight = 0;

  $(".trendingnow .prod-title").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  $(".trendingnow .prod-title").height(maxHeight);

  // 
  var maxHeight = 0;

  $(".ftr-box h2").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  $(".ftr-box h2").height(maxHeight);

  // 

  var maxHeight = 0;

  $(".mega-menu-dropdown .cate-type h5").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  $(".mega-menu-dropdown .cate-type h5").height(maxHeight);


  /*---------------- testimonial-slider ------------------*/ 
  $('.testimonial-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  // 

  /* blog section box height */ 
  var maxHeight = 0;
  $(".blogbox .blog-info").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    } 
  }); 
  $(".blogbox .blog-info").height(maxHeight); 
  /* blog section box height  end*/  


  /* footer mobile Dropdown */ 
  // 
  $(".collapsed-mobile").click(function() {
    $(".footer-block").toggleClass("");
    $(this).toggleClass("open");
  });
  /* footer mobile Dropdown End*/ 
  // 
  /*start: plus-minus quantity box*/
  $('.qty-btn.plus').click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  // This button will decrement the value till 0
  $(".qty-btn.minus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  /*end: plus-minus quantity box*/
  
  /*---------------- App Easy Responsive Tab ------------------*/
  if ($('#app-single-horizontal-tabs').length) {
    $('#app-single-horizontal-tabs').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
  /*---------------- App Responsive Tab ------------------*/
  
});
/*  */ 


/*---------------- Opening Review Tab on default Page Load ------------------*/
jQuery('#notify-me').click(function() {

jQuery('#notify-me-wrapper').fadeIn();

return false;
} );

$(document).on("focus", ".input", (function() {
    $(this).closest(".input_field").addClass("label-effect") 
}
))
$(document).on("focusout", ".input", (function() {
    $(this).val() ? $(this).closest(".input_field").addClass("label-effect") : $(this).closest(".input_field").removeClass("label-effect")
}
))

